var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultBankLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 48,
    viewBox: "0 0 120 48",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect232",
    style: {
      strokeWidth: 8.24352,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 2 2 L 2 46 L 118 46 L 118 2 L 2 2 z M 3 3 L 117 3 L 117 45 L 3 45 L 3 3 z "
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: "37.3333px",
      lineHeight: 1.25,
      fontFamily: "Lato",
      InkscapeFontSpecification: "Lato"
    },
    x: 17.720112,
    y: 36.991989,
    id: "text273"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan271",
    x: 17.720112,
    y: 36.991989,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "37.3333px",
      fontFamily: "'Nunito Sans'",
      InkscapeFontSpecification: "'Nunito Sans'"
    }
  }, "bank")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBankLogo);
export default __webpack_public_path__ + "static/media/defaultBankLogo.1b5e4ef775eab0e22444bf11837ff95d.svg";
export { ForwardRef as ReactComponent };